import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { Layout, Button, Icon, ConfigProvider, Empty } from "antd";

import i18next from "i18next";

class Page extends PureComponent {
  constructor(props) {
    super(props);
  }

  goBack() {
    window.history.back();
  }

  render() {
    const { Content } = Layout;
    let langAndDir = this.props.context;
    const customizeRenderEmpty = () => (
      <div style={{ textAlign: "center" }}>
        <Empty
          description={i18next.t("Empty")}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );

    return (
      <Content>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <h3>
            {" "}
            {this.props.hasBackArrow && (
              <Button
                onClick={() => {
                  if (this.props.callFlowBack) {
                    this.props.back();
                    return;
                  }
                  if (this.props.customerBack) {
                    this.props.back();
                    return;
                  }
                  if (this.props.ticketCategoryBack) {
                    this.props.back();
                    return;
                  }
                  if (this.props.customerTickets) {
                    this.props.back();
                    return;
                  }
                  this.goBack();
                }}
                ghost
                type="link"
                style={
                  langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                    ? { marginRight: "25px", color: "#e63c35" }
                    : { marginLeft: "25px", color: "#e63c35" }
                }
                icon={
                  langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                    ? "arrow-left"
                    : "arrow-right"
                }
              />
            )}{" "}
            {this.props.title}
          </h3>
          {this.props.children}
        </ConfigProvider>
      </Content>
    );
  }
}

export default withSharedStateConsumer(withRouter(Page));
